import { IressStack, IressText } from '@iress-oss/ids-components';
import { FC } from 'react';
import { usePageSearchParams } from '../../hooks';
import { useEntityDetailsQuery } from '../../services';

export const EntityDetailsDisplay: FC = () => {
    const { entityId } = usePageSearchParams();
    const { data } = useEntityDetailsQuery(entityId);
    const { displayName, displayDetails } = data ?? {};

    return (
        <IressStack gutter="xs">
            <IressText variant="display4">{displayName}</IressText>
            <IressText variant="display">{displayDetails}</IressText>
        </IressStack>
    );
};
